import { combineReducers } from 'redux';
import loading from './loading';
import config from './config';
import cart from './cart';
import toast from './toast';

export const rootReducer = combineReducers({
  config,
  loading,
  cart,
  toast
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;